import HiddenHeading from './HiddenHeading';

export default HiddenHeading;
